import * as React from "react";
import PropTypes from "prop-types";
import { Box, Grid } from "@material-ui/core";
import { SectionTitle, StyledGrid, Option } from "../../theme/Form";

const RememberMeSection = React.memo(function RememberMeSection({
  rememberMe,
  setRememberMe,
}) {
  return (
    <Box component="section" pb={4}>
      <SectionTitle title="Remember Me" />

      <StyledGrid container direction="column">
        <Grid item>
          <Option
            label="Save my information for a faster checkout"
            onClick={(evt) => setRememberMe(evt.target.checked)}
            type="checkbox"
            checked={rememberMe}
          />
        </Grid>
      </StyledGrid>
    </Box>
  );
});

RememberMeSection.propTypes = {
  rememberMe: PropTypes.bool,
  setRememberMe: PropTypes.func,
};

export default RememberMeSection;
